export default __webpack_public_path__ + "static/media/Bus.77d97fdd.svg";